import React, { useState, useEffect } from "react";
import { Rows3, Columns3 } from "lucide-react";

const CUSTOMER_MODE_KEY = "sg_customer_view_mode";

export function getCustomerViewMode() {
    return localStorage.getItem(CUSTOMER_MODE_KEY) || "standard";
}

export function useCustomerViewMode() {
    const [mode, setMode] = useState(getCustomerViewMode);
    useEffect(() => {
        const handler = () => setMode(getCustomerViewMode());
        window.addEventListener("sg_customer_mode_change", handler);
        return () => window.removeEventListener("sg_customer_mode_change", handler);
    }, []);
    const toggle = () => {
        const next = mode === "b2b" ? "standard" : "b2b";
        localStorage.setItem(CUSTOMER_MODE_KEY, next);
        window.dispatchEvent(new Event("sg_customer_mode_change"));
    };
    return [mode, toggle];
}

/**
 * B2BToggle - Customer-facing toggle for B2B compact view.
 * Shows in category page toolbar area.
 */
export function B2BToggle() {
    const [mode, toggle] = useCustomerViewMode();
    return (
        <button onClick={toggle}
            className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all border ${
                mode === "b2b"
                    ? "bg-green-50 border-green-300 text-green-700"
                    : "bg-white border-gray-200 text-gray-500 hover:bg-gray-50"
            }`}
            data-testid="b2b-view-toggle"
            title={mode === "b2b" ? "B2B rezim (kompaktni)" : "Standardni zobrazeni"}>
            {mode === "b2b" ? <Rows3 size={12} /> : <Columns3 size={12} />}
            {mode === "b2b" ? "B2B" : "Katalog"}
        </button>
    );
}
